module.exports = __webpack_public_path__ + "static/gallery21-eee9c692a3d57271098cde227da2549a.jpg";